import React from 'react';
import './GoogleSignInButton.css';

const GoogleSignInButton = ({ onClick, redirectUrl }) => {
  return (
    <button
      type="button"
      className="google-sign-in-button w-full"
      onClick={() => (window.location.href = redirectUrl)}
    >
      <span>
        <div className="flex items-center justify-center">
          <img
            src="/google_logo.svg"
            alt="Google Icon"
            className="google-icon"
          />
          <span className="text-dark font-semibold">Sign in with Google</span>
        </div>
      </span>
    </button>
  );
};

export default GoogleSignInButton;